import AppBar from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Toolbar from '@material-ui/core/Toolbar'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { logoutUser } from '../../api/authApi'
import { fetchEasymsOrganizations } from '../../api/easymsOrganizationsApi'
import LogoutIcon from '../LogoutIcon'
import OmnitecTab from './OmnitecTab'
import BookingTab from './BookingTab'
import DobovoTab from './DobovoTab'
import ExpediaTab from './ExpediaTab'
import Hotels24Tab from './Hotels24Tab'
import HWTab from './HWTab'
// import JsonDiffTab from './JsonDiffTab'
import OrderHistoryTab from './OrderHistoryTab'

const TabContainer = props => (
    <Typography component="div" style={{ padding: 0, backgroundColor: '#f5f5f5' }}>
        {props.children}
    </Typography>
)

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    tabs: {
        flex: 1
    },
    toolbar: {
        minHeight: '54px'
    }
})

class ChannelTabs extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    }

    componentDidMount() {
        this.props.fetchEasymsOrganizations()
    }

    state = { value: 0 }

    getToolbarColor = value =>
        ({
            // '0': { bg: '#003580', text: 'white' }, // Omnitec
            '0': { bg: '#003580', text: 'white' }, // Booking
            '1': { bg: '#cc8c45', text: 'white' }, // Hotels24
            '2': { bg: '#ff7346', text: 'white' }, // HostelWorld
            '3': { bg: '#f8f5f3', text: '#f31941' }, // Dobovo
            '4': { bg: '#ffcc00', text: '#00355f' }, // Expedia
            '5': { bg: '#2196f3', text: 'white' }, // Omnitec
            '6': { bg: '#f31941', text: 'ffcc00' } // Order History,
        }[value])

    handleChange = (event, value) => {
        this.setState({ value })
    }

    handleLogout = () => {
        localStorage.removeItem('easyMs_ChannelManager_Omnitec_CurrentOrganization')
        this.props.logoutUser()
    }

    render() {
        const { classes } = this.props
        const { value } = this.state

        return (
            <div className={classes.root}>
                <AppBar
                    position="static"
                    style={{ background: this.getToolbarColor(value).bg, color: this.getToolbarColor(value).text }}
                >
                    <Toolbar className={classes.toolbar}>
                        <Tabs
                            value={value}
                            onChange={this.handleChange}
                            className={classes.tabs}
                            scrollable
                            scrollButtons="auto"
                        >
                            <Tab label="Booking.com" />
                            <Tab label="Hotels24.ua" />
                            <Tab label="Hostelword.com" />
                            <Tab label="Dobovo.com" />
                            <Tab label="Expedia.com" />
                            {/* <Tab label="JSON diff" /> */}
                            <Tab label="Omnitec" />
                            <Tab label="Order History" />
                        </Tabs>
                        <Tooltip title="Выйти">
                            <IconButton onClick={this.handleLogout} color="inherit">
                                <LogoutIcon />
                            </IconButton>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                {value === 0 && (
                    <TabContainer>
                        <BookingTab />
                    </TabContainer>
                )}
                {value === 1 && (
                    <TabContainer>
                        <Hotels24Tab />
                    </TabContainer>
                )}
                {value === 2 && (
                    <TabContainer>
                        <HWTab />
                    </TabContainer>
                )}
                {value === 3 && (
                    <TabContainer>
                        <DobovoTab />
                    </TabContainer>
                )}
                {value === 4 && (
                    <TabContainer>
                        <ExpediaTab />
                    </TabContainer>
                )}
                {/* {value === 6 && (
                    <TabContainer>
                        <JsonDiffTab />
                    </TabContainer>
                )} */}
                {value === 5 && (
                    <TabContainer>
                        <OmnitecTab />
                    </TabContainer>
                )}
                {value === 6 && (
                    <TabContainer>
                        <OrderHistoryTab />
                    </TabContainer>
                )}
            </div>
        )
    }
}

export default withRouter(
    connect(
        null,
        { fetchEasymsOrganizations, logoutUser }
    )(withStyles(styles)(ChannelTabs))
)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ChannelTabs.js